
<template>
  <div
    id="Test-Report-Form"
    class="hbn-container"
  >
    <div class="page-title">工伤事故发展趋势统计分析</div>
    <div class="search-form">
      <el-form
        ref="form"
        :model="form"
        label-width="40px"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="时间">
              <el-date-picker
                style="width:10rem"
                v-model="SelectData.StartYear"
                value-format="YYYY-MM"
                format="YYYY-MM"
                type="month"
                size="large"
                :default-value="SelectData.StartYear"
              ></el-date-picker>
              至
              <el-date-picker
                style="width:10rem"
                v-model="SelectData.EndYear"
                value-format="YYYY-MM"
                format="YYYY-MM"
                type="month"
                size="large"
                :default-value="SelectData.EndYear"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="省-市-区">
              <el-select
                style="width:10rem"
                v-model="SelectData.ProvinceCode"
                filterable
                placeholder="请选择省"
                @change="ProvinceChange"
              >
                <el-option
                  v-for="item in ProvinceList"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>

              <el-select
                style="width:10rem"
                v-model="SelectData.CityCode"
                filterable
                placeholder="请选择市"
                @change="CityChange"
              >
                <el-option
                  v-for="item in CityList"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>

              <el-select
                style="width:10rem"
                v-model="SelectData.RegionCode"
                filterable
                placeholder="请选择区"
              >
                <el-option
                  v-for="item in RegionList"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="姓名">
              <el-input
                v-model="SelectData.InjuryUserName"
                placeholder="姓名"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工伤单位">
              <el-select
                v-model="SelectData.injuryUnitRange"
                size="small"
                placeholder="工伤单位"
                class="search-item-input search-item-select"
                multiple
                filterable
                collapse-tags
                collapse-tags-tooltip
                remote
                :remote-method="remoteMethodUnit"
              >
                <el-option
                  v-for="item in optionUnits"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <!-- <el-input
                v-model="PageQuery.queryModel.InjuryUnitName"
                placeholder="公司名称"
                clearable
              /> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button
              size="mini"
              class="hbn-button-serach"
              @click="GetData"
            >查找</el-button>
          </el-col>
        </el-row>
        <div class="foldDomain">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="伤害类型">
                <el-select
                  v-model="SelectData.injuryPartRange"
                  size="small"
                  placeholder="伤害类型"
                  class="search-item-input search-item-select"
                  multiple
                  filterable
                  collapse-tags
                  collapse-tags-tooltip
                  remote
                  :remote-method="remoteMethodInjuryPart"
                >
                  <el-option
                    v-for="item in injuryPartOpt"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="受伤部位">
                <el-select
                  v-model="SelectData.injurySiteRange"
                  size="small"
                  placeholder="受伤部位"
                  class="search-item-input search-item-select"
                  multiple
                  filterable
                  collapse-tags
                  collapse-tags-tooltip
                  remote
                  :remote-method="remoteMethodInjurySite"
                >
                  <el-option
                    v-for="item in injurySiteOpt"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="职业病">
                <el-select
                  v-model="SelectData.occupationDiseaseRange"
                  size="small"
                  placeholder="职业病"
                  class="search-item-input search-item-select"
                  multiple
                  filterable
                  collapse-tags
                  collapse-tags-tooltip
                  remote
                  :remote-method="remoteMethodoccupationDisease"
                >
                  <el-option
                    v-for="item in occupationDiseaseOpt"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属行业">
                <el-select
                  v-model="SelectData.injuryTypeRange"
                  size="small"
                  placeholder="所属行业"
                  class="search-item-input search-item-select"
                  multiple
                  filterable
                  collapse-tags
                  collapse-tags-tooltip
                  remote
                  :remote-method="remoteMethodinjuryType"
                >
                  <el-option
                    v-for="item in injuryTypeOpt"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="岗位">
                <el-input
                  v-model="SelectData.post"
                  placeholder="岗位"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="入职时间"
                prop="entryDate"
              >
                <el-date-picker
                  v-model="SelectData.entryDate"
                  type="daterange"
                  range-separator=" - "
                  start-placeholder="开始"
                  end-placeholder="结束"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="性别"
                prop="sex"
              >
                <el-select
                  v-model="SelectData.sex"
                  placeholder="性别"
                >
                  <el-option
                    v-for="item in SexList"
                    :key="item.val"
                    :label="item.name"
                    :value="item.val"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="年龄">
                <div class="ageRange">
                  <el-input-number
                    v-model="SelectData.ageRangeBegin"
                    class="w-50 m-2"
                    :suffix-icon="Calendar"
                    style="width:40%;"
                    :min="0"
                    :controls="false"
                  />
                  <span> &nbsp;-&nbsp; </span>
                  <el-input-number
                    v-model="SelectData.ageRangeEnd"
                    class="w-50 m-2"
                    :prefix-icon="Search"
                    style="width:40%;"
                    :min="0"
                    :controls="false"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="hbn-content">
      <div class="tab-item">
        <div class="flex-layer">
          <div class="screen-item">
            <div
              id="line-Chart"
              :style="{ width: '100%', height: '400px' }"
            ></div>
          </div>
          <div class="screen-item">
            <div
              id="bar-Chart"
              :style="{ width: '100%', height: '400px' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetInjuryDevelopmentTrendAlysisData,
  GetInjuryPostData,
} from "@api/ApiInjuryAffirmBill";
import { GetDataDministrativeDivisionsList } from "@api/ApiDministrativeDivisions";
import { Chart } from "highcharts-vue";
import { ProvinceList } from "@/assets/apiData/Province";
import { GetDataInjuryUnitList } from "@api/ApiInjuryUnit";
import { GetDatainjuryPartList } from "@api/ApiInjuryPart";
import { GetDataInjurySiteList } from "@api/ApiInjurySite";
import { GetDataOccupationDiseaseList } from "@api/ApiOccupationDisease";
import { GetDataInjuryTypeList } from "@api/ApiInjuryType";
import { getSystemConfigByKey } from "@/util/authority";

import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import loadExporting from "highcharts/modules/exporting";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
loadExporting(Highcharts);

export default {
  name: "InjuryDevelopmentTrendAlysis",
  data() {
    return {
      SelectData: {
        StartYear: (new Date().getFullYear() - 2).toString() + "-01",
        EndYear: new Date().getFullYear().toString() + "-12",
        ProvinceCode: "",
        CityCode: "",
        InjuryUserName: "",
        InjuryUnitName: "",
        injuryUnitRange: [],
        injuryPartRange: [],
        injurySiteRange: [],
        occupationDiseaseRange: [],
        injuryTypeRange: [],
        post: "",
        injuryTime: [],
        injuryTimeBegin: "",
        injuryTimeEnd: "",
        sex: "",
        ageRangeBegin: "",
        ageRangeEnd: "",
      },
      startPickerOptions: {},
      endPickerOptions: {},
      DataList: [],
      Page2TableDataList: [],
      lang: {
        viewFullscreen: "全屏查看",
        printChart: "打印",
        downloadJPEG: "下载JPEG 图片",
        downloadPDF: "下载PDF文档",
        downloadPNG: "下载PNG 图片",
        downloadSVG: "下载SVG 矢量图",
        exportButtonTitle: "导出图片",
      },
      colors: [
        "#4F94CD",
        "#8085E9",
        "#058DC7",
        "#50B432",
        "#ED561B",
        "#24CBE5",
        "#64E572",
        "#FF9655",
        "#87CEEB",
        "#7EC0EE",
        "#79CDCD",
        "#7171C6",
        "#C1FFC1",
        "#7FFFD4",
      ],
      Page2TableHeader: [],
      titleName: "折线图",
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      Posts: [], //岗位
      optionPosts: [],
      Units: [], //工伤单位
      optionUnits: [],
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 10000,
      },
      IsShowReportSubTitle: "0", //报表是否展示标语
      SexList: [
        { name: "男", val: 0 },
        { name: "女", val: 1 },
      ],
      injuryPartList: [],
      injuryPartOpt: [],
      injurySiteList: [],
      injurySiteOpt: [],
      occupationDiseaseList: [],
      occupationDiseaseOpt: [],
      injuryTypeList: [],
      injuryTypeOpt: [],
    };
  },
  components: {
    highcharts: Chart,
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.IsShowReportSubTitle = getSystemConfigByKey("IsShowReportSubTitle");
      this.GetData();
      this.GetDataDministrativeDivisions();
      this.loadData();
    });
  },
  methods: {
    loadData() {
      //加载岗位和工伤单位数据
      var _this = this;
      GetInjuryPostData().then(function (data) {
        _this.Posts = data;
        _this.optionPosts = data;
      });
      let PageQuery = {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 100000,
      };
      GetDataInjuryUnitList(PageQuery).then(function (data) {
        _this.Units = data.entities;
      });
      GetDatainjuryPartList(PageQuery).then(function (data) {
        _this.injuryPartList = data.entities;
      });
      GetDataInjurySiteList(PageQuery).then(function (data) {
        _this.injurySiteList = data.entities;
      });
      GetDataOccupationDiseaseList(PageQuery).then(function (data) {
        _this.occupationDiseaseList = data.entities;
      });
      GetDataInjuryTypeList(PageQuery).then(function (data) {
        _this.injuryTypeList = data.entities;
      });
    },
    remoteMethodUnit(query) {
      if (query !== "") {
        this.optionUnits = this.Units.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.optionUnits = this.Units;
      }
    },
    remoteMethodInjuryPart(query) {
      if (query !== "") {
        this.injuryPartOpt = this.injuryPartList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injuryPartOpt = this.injuryPartList;
      }
    },
    remoteMethodInjurySite(query) {
      if (query !== "") {
        this.injurySiteOpt = this.injurySiteList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injurySiteOpt = this.injurySiteList;
      }
    },
    remoteMethodoccupationDisease(query) {
      if (query !== "") {
        this.occupationDiseaseOpt = this.occupationDiseaseList.filter(
          (item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
        );
      } else {
        this.occupationDiseaseOpt = this.occupationDiseaseList;
      }
    },
    remoteMethodinjuryType(query) {
      if (query !== "") {
        this.injuryTypeOpt = this.injuryTypeList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injuryTypeOpt = this.injuryTypeList;
      }
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.Page2TableHeader)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.Page2TableHeader)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.Page2TableDataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `工伤认定统计-` + v.titleName);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    /**
     * 折线图
     */
    lineChart() {
      const seriesData = [],
        categoriesData = [];
      const data = [];
      this.DataList.forEach((e) => {
        categoriesData.push(e.year);
        data.push(e.group_Count);
      });

      seriesData.push({
        name:
          this.SelectData.StartYear +
          "-" +
          this.SelectData.EndYear +
          " 年工伤人数",
        data: data,
        lineWidth: 3, // 线宽
        cursor: "pointer", // 鼠标样式
        dashStyle: "Solid", // 线条样式
      });

      // 初始化 Highcharts 图表
      new Highcharts.Chart("line-Chart", {
        credits: {
          enabled: false, // 禁用版权信息
        },
        exporting: {
          filename:
            this.SelectData.StartYear +
            "-" +
            this.SelectData.EndYear +
            " 年工伤人数-折线图",
        },
        title: {
          text: "折线图",
        },
        subtitle: {
          text:
            this.IsShowReportSubTitle == "1"
              ? "数据来源:铁安通工伤预防智能帮手"
              : "",
        },
        colors: this.colors,
        lang: this.lang,
        // X轴
        xAxis: {
          // title: {
          //   text: "年",
          // },
          // 数据项
          categories: categoriesData,
        },
        // Y轴
        yAxis: {
          title: {
            align: "high",
            textAlign: "left",
            rotation: 0,
            offset: 0,
            margin: 0,
            y: -20,
            x: -15,
            text: "工伤人数",
          },
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
            marker: {
              radius: 1, // 大小
              enabled: true, // 为true时，自定义显示 下方label无效
              states: {
                // 状态
                hover: {
                  radius: 2,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        series: seriesData,
      });
    },
    /**
     * 柱状图
     */
    barChart() {
      const categoriesData = [];
      const seriesData = [];
      this.DataList.forEach((e) => {
        categoriesData.push(e.year);
        seriesData.push(e.group_Count);
      });

      // 初始化 Highcharts 图表
      new Highcharts.Chart("bar-Chart", {
        credits: {
          enabled: false, // 禁用版权信息
        },
        exporting: {
          filename:
            this.SelectData.StartYear +
            "-" +
            this.SelectData.EndYear +
            " 年工伤人数-柱状图",
        },
        title: {
          text: "柱状图",
        },
        chart: {
          type: "column",
        },
        subtitle: {
          text:
            this.IsShowReportSubTitle == "1"
              ? "数据来源:铁安通工伤预防智能帮手"
              : "",
        },
        lang: this.lang,
        // X轴
        xAxis: {
          // 数据项
          categories: categoriesData,
          crosshair: true,
        },
        // Y轴
        yAxis: {
          title: {
            align: "high",
            textAlign: "left",
            rotation: 0,
            offset: 0,
            margin: 0,
            y: -20,
            x: -15,
            text: "工伤人数",
          },
          // 标示线
          plotLines: [
            {
              value: 0,
              width: 1,
              color: "#808080",
            },
          ],
        },
        colors: this.colors,
        tooltip: {
          valueSuffix: "人", // 提示信息所带单位
        },
        legend: {
          enabled: false, //  禁用图例
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            marker: {
              radius: 1, // 大小
              enabled: true, // 为true时，自定义显示 下方label无效
              states: {
                // 状态
                hover: {
                  radius: 2,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        series: [{ data: seriesData }],
      });
    },
    GetData() {
      const _this = this;
      // _this.SelectData.UnitIds=""
      // _this.SelectData.Posts=""
      // _this.SelectData.UnitIds=_this.SelectData.UnitIdArr.join(',');
      // _this.SelectData.PostArr.forEach(x=>{
      //    _this.SelectData.Posts+="'"+x+"',";
      // })
      GetInjuryDevelopmentTrendAlysisData(this.SelectData).then(function (
        data
      ) {
        _this.DataList = data;
        _this.lineChart();
        _this.barChart();
      });
    },
    GetDataDministrativeDivisions() {
      // const _this = this
      // GetDataDministrativeDivisionsList({
      //   pageSize: 1000,
      //   pageIndex: 1,
      //   queryModel: {
      //     level : 2,
      //     showChildren : true
      //   }
      // }).then(function(data){
      //   _this.ProvinceList = data.entities
      //   _this.ProvinceList.unshift({
      //     areaName:"-请选择-",
      //     code:""
      //   })
      // });
    },
    ProvinceChange() {
      const _this = this;
      _this.SelectData.CityCode = "";
      _this.ProvinceList.map((x) => {
        if (x.code == _this.SelectData.ProvinceCode) {
          _this.CityList = JSON.parse(JSON.stringify(x.children));
          _this.CityList.unshift({
            areaName: "-请选择-",
            code: "",
          });
        }
      });
    },
    CityChange() {
      const _this = this;
      _this.SelectData.RegionCode = "";
      _this.ProvinceList.map((x) => {
        if (x.code == _this.SelectData.ProvinceCode) {
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == _this.SelectData.CityCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            code: "",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
</style>
<style lang='scss' scoped>
@import "../../common/css/Hbn_modules/hbn-base-model";
.hbn-content {
  .screen-item {
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    border: 1px solid #d8dee8;
    position: relative;
    margin-bottom: 26px;
  }

  .custom-chart-title {
    height: 58px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(216, 222, 232, 1);

    .chart-name {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33404e;
    }

    .hbn-load {
      width: 73px;
      max-height: 32px;
      min-height: 32px;
      background: #0747a6;
      border-radius: 2px 2px 2px 2px;
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      padding: 0;
      border: 0;

      .el-icon-download {
        font-size: 18px;
      }
    }
  }
  .flex-layer {
    display: flex;
    justify-content: space-between;
    .screen-item {
      width: calc(50% - 11px);
      .pie-custom-title {
        position: absolute;
        top: 68px;
        width: 100%;
        .text {
          text-align: center;
          font-weight: 500;
        }
        .name {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #8c8c8c;
          line-height: 22px;
          margin-bottom: 14px;
        }
        .sub {
          .pie-unit {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #404c59;
            line-height: 22px;
          }
          .num {
            font-size: 32px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #404c59;
            line-height: 22px;
          }
        }
      }
    }
  }
  .hbn-pagination-layer {
    display: flex;
    padding-top: 20px;
    justify-content: flex-end;
  }
}
</style>
<style scoped>
.search-form {
  padding: 10px 0;
}

.search-form /deep/ .is-guttered {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.custom-table-header > th {
  background: #dfdfdf !important;
}
.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}
.hbn-content /deep/ .el-table .cell {
  color: #32383d;
}
</style>